import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const base =
  "inline-flex items-center justify-center gap-2 rounded-lg text-xs sm:text-sm font-bold uppercase tracking-widest px-6 sm:px-8 py-3.5 focus:outline-none focus:ring-2 focus:ring-[#009BFF]/60";
const heading = { fontFamily: "var(--font-heading)" };

export const PrimaryButton = ({ to, href, children, className = "", ...rest }) => {
  const cls = `${base} text-white bg-gradient-to-r from-[#006FD6] to-[#009BFF] shadow-[0_4px_20px_rgba(0,111,214,0.4)] hover:shadow-[0_6px_28px_rgba(0,155,255,0.55)] hover:brightness-110 transition-[box-shadow,filter] duration-300 ${className}`;
  const Inner = ({ c }) => (
    <motion.span whileTap={{ scale: 0.97 }} className="contents">{c}</motion.span>
  );
  if (to) return <Link to={to} className={cls} style={heading} {...rest}><Inner c={children} /></Link>;
  if (href) return <a href={href} className={cls} style={heading} {...rest}><Inner c={children} /></a>;
  return <button className={cls} style={heading} {...rest}><Inner c={children} /></button>;
};

export const OutlineButton = ({ to, href, children, dark = true, className = "", ...rest }) => {
  const palette = dark
    ? "text-white border-[#009BFF]/60 hover:border-[#00C4F4] hover:bg-[#009BFF]/10"
    : "text-[#041525] border-[#062541]/30 hover:border-[#006FD6] hover:bg-[#006FD6]/5";
  const cls = `${base} border-2 bg-transparent transition-colors duration-300 ${palette} ${className}`;
  if (to) return <Link to={to} className={cls} style={heading} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} style={heading} {...rest}>{children}</a>;
  return <button className={cls} style={heading} {...rest}>{children}</button>;
};
